import { c as _c } from "react/compiler-runtime";
import { AdvantageBoxes } from '@/components/boxes';
import { SectionHeadline } from '@/components/SectionHeadline';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { Text } from '@/components/typography';
import React from 'react';
export function Sales() {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["xmas"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("sale.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mx-auto mb-4 max-w-192" anchorKey="sale.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("sale.subtitle");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Text variant="p2" className="mx-auto mb-10 max-w-[48rem] text-center text-gray-800 lg:mb-12">{t3}</Text>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("sale.items.1.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link className="block" analyticsParam="xmasFaq" testId="xmasFaq" to={LINKS().faqQuestion("nakup-na-tretinu", "jak-prevest-tretinu-do-vyuctovani")} />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = <Trans t={t} i18nKey="sale.items.1.text">{t6}</Trans>;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = {
      image: "/images/sections/xmas/sales/1.png",
      title: t5,
      text: t7
    };
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("sale.items.2.title");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("sale.items.2.text");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = {
      image: "/images/sections/xmas/sales/2.png",
      title: t9,
      text: t10
    };
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t8) {
    t12 = <AdvantageBoxes className="md-px-4 max-w-[50rem] grid-cols-2 grid-rows-1" items={[t8, t11]} />;
    $[24] = t11;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t2 || $[29] !== t4) {
    t13 = <div className="relative z-10">{t2}{t4}{t12}</div>;
    $[27] = t12;
    $[28] = t2;
    $[29] = t4;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}